<template>
  <div class="task-type-box">
    <el-scrollbar style="width:500px;height:400px" wrap-style="overflow-x:hidden">
      <h2>
        查看{{ form.type == 1 || form.type == 8? '提醒任务' : form.type == 2 ? '问诊说明' : form.type == 3 ? '随访说明' : form.type == 4 ? '评估说明' : form.type == 5 ? '复诊计划' : form.type == 6 ? '重点指标' : form.type == 7 ? '及时反馈' : ''}}方案
      </h2>
      <!-- 1:提醒任务(重点指标任务) 3:随访说明 4:评估说明 5:复诊计划 8：提醒任务（普通任务） -->
      <!-- 提醒任务 -->
      <el-form :model="form" label-suffix="：" label-width="150px" size="mini" v-if="form.type == 1 || form.type == 8">
        <el-form-item label="任务方案标题">
          <span>{{ form.itemName }}</span>
        </el-form-item>
        <el-form-item label="任务类型">
          <span>{{ form.executeType == 11 ? '普通任务': '重点指标收集任务'}}</span>
        </el-form-item>
        <el-form-item label="提醒时间">
          <span v-if="form.itemTime != ''">提前{{ form.itemTime }}天</span>
        </el-form-item>
        <el-form-item label="任务频率">
          <span>{{form.cycleStr}}</span>
        </el-form-item>
        <el-form-item label="任务属性">
          <span>{{ form.attrs == 1 ? '长期' : form.attrs == 2 ? '短期' : '' }}</span>
        </el-form-item>
        <el-form-item label="短期任务属性" v-if="form.attrs == 2">
          <span>{{ form.shortDays }} {{ form.shortDaysType }}</span>
        </el-form-item>
        <el-form-item label="任务方案备注">
          <span>{{ form.description }}</span>
        </el-form-item>
        <el-form-item label="任务方案开始时间">
          <span>{{ form.schemeTimeAxisName }}</span>
        </el-form-item>
        <el-form-item label="与开始时间间隔">
          <span>{{ form.startIntervalTime }} {{ form.startIntervalType }}</span>
        </el-form-item>
      </el-form>
      <!-- 随访说明 -->
      <el-form :model="form" label-suffix="：" label-width="150px" size="mini" v-if="form.type == 3">
        <el-form-item label="随访计划名称订单">
          <span> {{form.itemName}}</span>
        </el-form-item>
        <el-form-item label="随访方式">
          <span>{{ form.method == 4 ? '病人自主' : form.method == 5 ? '个案评估' : form.method == 6 ? '医生评估' : "" }}</span>
        </el-form-item>
        <el-form-item label="随访类型">
          <span>{{ form.executeType == 1 ? '线上' : form.executeType == 2 ? '线下' : "" }}</span>
        </el-form-item>
        <el-form-item label="提醒时间">
          <span v-if="form.itemTime != ''">提前{{ form.itemTime }}天</span>
        </el-form-item>
        <el-form-item label="随访频率">
          <span>{{form.cycleStr}}</span>
        </el-form-item>
        <el-form-item label="随访属性">
          <span>{{ form.attrs == 1 ? '长期' : form.attrs == 2 ? '短期' : '' }}</span>
        </el-form-item>
        <el-form-item label="随访宣教属性" v-if="form.attrs == 2">
          <span>>{{ form.shortDays }} {{ form.shortDaysType }}</span>
        </el-form-item>
        <el-form-item label="随访内容备注">
          <span>{{ form.description }}</span>
        </el-form-item>
        <el-form-item label="随访方案开始时间">
          <span>{{ form.schemeTimeAxisName }}</span>
        </el-form-item>
        <el-form-item label="与开始时间间隔">
          <span>{{ form.startIntervalTime }} {{ form.startIntervalType }}</span>
        </el-form-item>
      </el-form>
      <!-- 评估说明 -->
      <el-form :model="form" label-suffix="：" size="mini" label-width="150px" v-if="form.type == 4">
        <el-form-item label="评估名称">
          <span> {{form.itemName}}</span>
        </el-form-item>
        <el-form-item label="评估方式">
          <span>{{ form.method == 4 ? '病人自主' : form.method == 5 ? '个案评估' : form.method == 6 ? '医生评估' : "" }}</span>
        </el-form-item>
        <el-form-item label="评估类型">
          <span>{{ form.executeType == 1 ? '线上' : form.executeType == 2 ? '线下' : "" }}</span>
        </el-form-item>
        <el-form-item label="提醒时间">
          <span v-if="form.itemTime != ''">提前{{ form.itemTime }}天</span>
        </el-form-item>
        <el-form-item label="评估频率频率">
          <span>{{form.cycleStr}}</span>
        </el-form-item>
        <el-form-item label="评估属性">
          <span>{{ form.attrs == 1 ? '长期' : form.attrs == 2 ? '短期' : '' }}</span>
        </el-form-item>
        <el-form-item label="短期评估属性" v-if="form.attrs == 2">
          <span>>{{ form.shortDays }} {{ form.shortDaysType }}</span>
        </el-form-item>
        <el-form-item label="评估内容备注">
          <span>{{ form.description }}</span>
        </el-form-item>
        <el-form-item label="评估方案开始时间">
          <span>{{ form.schemeTimeAxisName }}</span>
        </el-form-item>
        <el-form-item label="与开始时间间隔">
          <span>{{ form.startIntervalTime }} {{ form.startIntervalType }}</span>
        </el-form-item>
      </el-form>
      <!-- 复诊计划 -->
      <el-form :model="form" label-suffix="：" label-width="160px" size="mini" v-if="form.type == 5">
        <el-form-item label="复诊计划名称">
          <span>{{ form.itemName }}</span>
        </el-form-item>
        <el-form-item label="提醒时间">
          <span>提前{{ form.itemTime }}天</span>
        </el-form-item>
        <el-form-item label="复诊频率">
          <span>{{ form.cycleStr }}</span>
        </el-form-item>
        <el-form-item label="复诊属性">
          <span>{{ form.attrs == 1 ? '长期' : form.attrs == 2 ? '短期' : '' }}</span>
        </el-form-item>
        <el-form-item label="短期复诊属性" v-if="form.attrs == 2">
          <span>{{ form.shortDays }} {{ form.shortDaysType }}</span>
        </el-form-item>
        <el-form-item label="复诊计划注意事项">
          <span> {{form.refName && form.refName.length>20 ? form.refName.substring(0,20)+'...' : form.refName}}</span>
        </el-form-item>
        <el-form-item label="复诊内容">
          <span>{{ form.advantage }}</span>
        </el-form-item>
        <el-form-item label="复诊计划方案开始时间">
          <span>{{ form.schemeTimeAxisName }}</span>
        </el-form-item>
        <el-form-item label="与开始时间间隔">
          <span>{{ form.startIntervalTime }} {{ form.startIntervalType }}</span>
        </el-form-item>
        <el-form-item label="是否需要回传检查报告">
          <span>{{ form.checkStatus ? '是' : '否' }}</span>
        </el-form-item>
      </el-form>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  name: "taskDetails",
  props: {
    form: {
      type: Object
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="less">
.task-type-box {
  padding: 10px 20px 0;
  h2 {
    font-weight: bold;
    font-size: 14px;
    color: #000;
    text-align: center;
    margin-bottom: 15px;
  }
  /deep/.el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>